/*
 * File: /src/components/modals/ModalFieldCode.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 25th July 2018 12:44:17 pm
 * Last Modified: Tuesday, 28th August 2018 5:09:43 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="title"></h1>
    <Prism class="modal-field__pre-code modals-container__scroll-content" language="liquid-html">
      {{ liquidCode }}
    </Prism>
    <textarea class="modal-field__textarea-code" ref="code" v-model="liquidCode">
    </textarea>
    <div class="modal-field__buttons">
      <BaseButton title="Close" @click.native="closeModal"/>
      <BaseButton :title="copyButtonText" @click.native="handleCopy" theme="primary"/>
    </div>
  </div>
</template>

<script>
  import { FieldLiquidGenerateHeleper } from '@/helpers'
  import 'prismjs'
  import 'prismjs/themes/prism.css'
  import Prism from 'vue-prism-component'
  import { MDSModalFieldCodeModel } from '@/models/modal-datasets.model'

  export default {
    components: {
      Prism
    },
    data () {
      return {
        title: null,
        copyButtonText: 'Copy',
        schema: null
      }
    },
    props: {
      modalData: MDSModalFieldCodeModel
    },
    computed: {
      liquidCode () {
        let field = this.modalData.field
        let scope = this.modalData.scope
        let schema = this.schema

        return FieldLiquidGenerateHeleper({ field, scope, schema })
      }
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      async handleCopy () {
        this.$refs.code.select()
        document.execCommand('copy')

        this.copyButtonText = 'Copied to clipboard!'
        
      },
      async setSchema () {
        if (this.modalData.field.type === 'custom-object') {
          let customObjects = this.$store.getters['shopCustomobjectsgroupsList/customObjectsGroupsMapped']
          if (!customObjects.length) {
            await this.$store.dispatch('shopCustomobjectsgroupsList/GET_CUSTOM_OBJECTS_GROUPS')
            customObjects = this.$store.getters['shopCustomobjectsgroupsList/customObjectsGroupsMapped']
          }

          let customObject = customObjects.find((item) => {
            return item.id === parseInt(this.modalData.field.subForm.groupID)
          })

          if (customObject.schema) {
            this.schema = customObject.schema
          }
        } else if (this.modalData.field.type === 'relation') {
          this.schema = this.modalData.field.subForm
        }

        return
      },
      setTitle () {
        const { label } = this.modalData.field
        this.title = `Liquid code for <strong>${label}</strong>`
      },
      handleKeyEvent (e) {
        if (e.keyCode === 13) {
          this.handleSubmit()
        }
      },
      collectForm (form) {
        this.form = form
      }
    },
    created () {
      this.setTitle()
      require('./prism-liquid-html') // if imported at top, there is collision with 'codeflask' from BaseHtml.vue
    },
    async mounted () {
      await this.setSchema()
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    destroyed () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalFieldCode.vue